import React from 'react';
import { Box } from '@mui/material';
import CatalogPage from '../components/CatalogPage';
import Image from '../components/Image';
import { useCatalogState } from '../hooks/useCatalogState';

export default function AccessoryPage() {
  const state = useCatalogState('accessory');

  if (state.loading) {
    return null;
  }

  return (
    <CatalogPage
      title="装飾品管理"
      state={state}
      onTogglePossession={(id) => {
        const current = state.items.find((item) => String(item.id) === String(id));
        const wasPossessed = Boolean(current?.possessed);
        state.togglePossession(id);
        if (!wasPossessed) {
          state.setRarity(id, '+1');
        }
      }}
      onSetRarity={state.setRarity}
      rarityOptions={[]}
      renderRarityControl={(item, onSetRarity, { interactive = true } = {}) => {
        const selected = Number(String(item.rarity || '+0').replace('+', '')) || 0;
        const disabled = !item.possessed || !interactive;
        const levels = [1, 2, 3, 4, 5, 6];

        const handlePick = (value) => {
          if (disabled) return;
          const next = selected === value ? '+0' : `+${value}`;
          onSetRarity(item.id, next);
        };

        return (
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              gap: 0.5,
              py: 1,
              opacity: disabled ? 0.3 : 1,
              flexWrap: 'wrap'
            }}
          >
            {levels.map((value) => {
              const active = selected >= value;
              const isBlue = value === 6;
              const color = isBlue ? '#60a5fa' : '#facc15';
              const shadow = isBlue ? 'rgba(96, 165, 250, 0.8)' : 'rgba(250, 204, 21, 0.8)';
              return (
                <Box
                  key={`acc-star-${value}`}
                  onClick={() => handlePick(value)}
                  sx={{
                    cursor: disabled ? 'default' : 'pointer',
                    fontSize: '1rem',
                    lineHeight: 1,
                    color: active ? color : 'rgba(255,255,255,0.15)',
                    textShadow: active ? `0 0 10px ${shadow}` : 'none',
                    transition: 'all 0.2s',
                    '&:hover': { transform: disabled ? 'none' : 'scale(1.2)' },
                    userSelect: 'none'
                  }}
                >
                  ★
                </Box>
              )
            })}
          </Box>
        );
      }}
      renderMainImage={(item) => (
        <Image
          src={`/img/accessory/${item.id}.png`}
          alt={item.accessory_name || item.name}
          style={{
            width: '100%',
            aspectRatio: '1 / 1',
            objectFit: 'cover',
            filter: item.possessed ? 'none' : 'grayscale(100%)',
          }}
        />
      )}
      renderOverlay={(item) => (
        <Image
          src={`/img/chara/${item.id}.png`}
          alt={item.name}
          style={{
            position: 'absolute',
            width: '32%',
            top: 4,
            left: 4,
            borderRadius: '50%',
            border: '2px solid #0f172a',
          }}
        />
      )}
    />
  );
}
